import api from './api';

const whatsappService = {
  async getSettings() {
    const response = await api.get('/v1/me/whatsapp/settings');
    return response.data;
  },

  async updateSettings(enabled) {
    const response = await api.put('/v1/me/whatsapp/settings', { enabled });
    return response.data;
  },

  async listMessages(page = 1, pageSize = 20) {
    const response = await api.get('/v1/me/whatsapp/messages', { params: { page, pageSize } });
    return response.data;
  },
};

export default whatsappService;
